import MortgageForm from "../../../../../components/data-capture/MortgageForm";
import React from "react";

export default function ApplicationForm({section, inExtWindow=true}) {
    section.index = section.mortgage.property.id
    console.log({section, inExtWindow});
    const questions = [
        {
            name: 'berDiscussed',
            label: 'BER Discussed',
            answer: {
                type: 'choice',
                choices: [
                    {
                        value: true,
                        text: 'Yes'
                    },
                    {
                        value: false,
                        text: 'No'
                    }
                    ]
            },
            target: `properties[${section.index}].berDiscussed`
        },
        {
          name: 'berDateOfIssue',
            label: 'BER Date of Issue',
            answer: {
                type: 'date',
            },
            target: `properties[${section.index}].berDateOfIssue`

        },
        {
            name: 'berReference',
            label: 'BER Reference',
            answer: {
                type: 'text',
            },
            target: `properties[${section.index}].berReference`
        },
        {
            name: 'berExpiryDate',
            label: 'BER Expiry Date',
            answer: {
                type: 'date',
            },
            target: `properties[${section.index}].berExpiryDate`
        },
        {
            name: 'berEmissions',
            label: 'BER Emissions',
            answer: {
                type: 'text',
            },
            target: `properties[${section.index}].berEmissions`
        },
        {
            name: 'berKwhPerM2',
            label: 'BER kWh/m2',
            answer: {
                type: 'text',
            },
            target: `properties[${section.index}].berKwhPerM2`
        },
        {
            name:'berExemptionConfirmed',
            label: 'BER Exemption Confirmed',
            answer: {
                type: 'choice',
                choices: [
                    {
                        value: true,
                        text: 'Yes'
                    },
                    {
                        value: false,
                        text: 'No'
                    }
                ]
            },
            target: `properties[${section.index}].berExemptionConfirmed`
        }
    ]
    return (
        <MortgageForm inExtWindow={inExtWindow} questions={questions}/>
    );
}
